import type { ExtensionSettingsBooleans, OverviewWidgetId } from "./types";

export const ALL_WIDGET_IDS: readonly OverviewWidgetId[] = [
    "firmographics",
    "signals",
    "salesforceActivity",
    "trafficVisits",
    "trafficShare",
    "technologies",
    "engagement",
    "adNetworks",
    "ecommerce",
];

export const DEFAULT_BOOLEAN_SETTINGS: ExtensionSettingsBooleans = {
    enableGmailAgent: true,
    enableGoogleCalendarAgent: true,
    enableLinkedin: true,
    autoOpenLinkedin: true,
    enableSalesforce: true,
    autoOpenSalesforceEnabled: false,
    enableHubspot: true,
    autoOpenHubspotEnabled: false,
    enableDynamics: true,
    autoOpenDynamicsEnabled: false,
    enableSalesloft: true,
    autoOpenSalesloftEnabled: false,
    enableOutlookCalendar: true,
    enableGoogleWorkspace: true,
    enableGmail: true,
    enableGoogleCalendar: true,
    enableGoogleSheets: true,
    showFloatingBadge: true,
};
